import TopNav from "@/components/TopNav";
import NotificationBubbles from "@/components/NotificationBubbles";
import { Outlet } from "react-router-dom";

export default function AppLayout() {
  return (
    <div className="min-h-screen paper text-[#1A0810]">
      <TopNav />
      <main className="mx-auto max-w-[1400px] px-6 lg:px-8 py-8">
        <Outlet />
      </main>
      <NotificationBubbles />
      <footer className="border-t border-[#E5DFD3] mt-16">
        <div className="mx-auto max-w-[1400px] px-6 lg:px-8 py-6 flex items-center justify-between text-xs text-[#6B5D57]">
          <span>© {new Date().getFullYear()} Grupo Vértice · Despacho Legal</span>
          <span>San José, Costa Rica</span>
        </div>
      </footer>
    </div>
  );
}
